import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/no-image.png'
import _imports_1 from '@/assets/img/pickup-button-vector.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4f63f49a")

_pushScopeId("data-v-4f63f49a")
const _hoisted_1 = { id: "All" }
const _hoisted_2 = { class: "all" }
const _hoisted_3 = { class: "all-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline all-headline" }, "全てのタレント", -1)
const _hoisted_5 = { class: "all-talent" }
const _hoisted_6 = { class: "all-talent-container" }
const _hoisted_7 = {
  key: 0,
  class: "all-img",
  src: _imports_0
}
const _hoisted_8 = { class: "talent-name txt txt-small" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "button-vector",
  src: _imports_1
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Imgix = _resolveComponent("Imgix")
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allTalents.slice(0, 8), (all, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "all-talent-box",
                onClick: ($event: any) => (_ctx.openTalent(all.talentID))
              }, [
                (all.mainImage === '')
                  ? (_openBlock(), _createBlock("img", _hoisted_7))
                  : (_openBlock(), _createBlock(_component_Imgix, {
                      key: 1,
                      class: "all-img",
                      imageUrl: all.mainImage,
                      imageSize: _ctx.imageSize
                    }, null, 8, ["imageUrl", "imageSize"])),
                _createVNode("div", _hoisted_8, _toDisplayString(all.formatDisplayName), 1)
              ], 8, ["onClick"]))
            }), 256))
          ])
        ])
      ]),
      _createVNode(_component_router_link, { to: { name: 'AllTalentsScreen' } }, {
        default: _withId(() => [
          _createVNode(_component_BaseRoundRectButton, { text: "もっと見る" }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
})